import {
  InitialState,
  NotificationActions,
  SHOW_NOTIFICATION,
  HIDE_NOTIFICATION,
  NotificationState
} from './types'



const NotificationReducer = (state: NotificationState = InitialState, action: NotificationActions): NotificationState => {
  switch (action.type) {

    case SHOW_NOTIFICATION: {
      return {
        ...state,
        openNotification: action.payload,
      }
    }

    case HIDE_NOTIFICATION: {
      return {
        ...state,
        openNotification: null,
      }
    }

    default:
      return state
  }
}

export default NotificationReducer